import { addressWork, addressHome, addressOther } from 'containers/pages/users/data';

/**
 * @function convertAddresses
 * @param { object } user
 * @returns { object }
 */
function convertAddresses(user) {
	let _addressWork = null;
	let _addressHome = null;
	let _addressOther = null;
	let addressObj = {};

	for (let i = 0; i < user.addressIds.length; i++) {
		for (let j = 0; j < user.addresses.length; j++) {
			if (user.addressIds[i].address_id === user.addresses[j].address_id) {
				const streetArr = user.addresses[j].line1.split(',');

				addressObj = {
					address_id: user.addresses[j].address_id,
					type: user.addressIds[i].address_type_id,
					street: streetArr[0],
					city: user.addresses[j].city,
					province: user.addresses[j].province,
					country: user.addresses[j].country,
					postalCode: user.addresses[j].postal_code,
					placeId: user.addresses[j].place_id,
					coordinate: { lat: user.addresses[j].lat, lng: user.addresses[j].lng },
					unit: streetArr[1],
					fullAddress:
						user.addresses[j].line1 +
						' ' +
						user.addresses[j].country +
						' ' +
						user.addresses[j].postal_code,
				};

				if (addressObj.type === '4') {
					_addressWork = addressObj;
				} else if (addressObj.type === '5') {
					_addressHome = addressObj;
				} else if (addressObj.type === '6') {
					_addressOther = addressObj;
				}
			}
		}
	}

	_addressWork ??= addressWork;
	_addressHome ??= addressHome;
	_addressOther ??= addressOther;

	return { _addressWork, _addressHome, _addressOther };
}

export default convertAddresses;
